// Custom JS for Mega Nav

document.addEventListener('DOMContentLoaded', function() {
    const dropdownLinks = document.querySelectorAll('.navmenu-link-title');
    const megaNav = document.querySelector('.navmenu-meganav');

    // Function to reset to original state (first tab active)
    function resetToOriginalState() {
        // Hide all dropdowns
        document.querySelectorAll('.nav-dropdown').forEach(dropdown => {
            dropdown.style.opacity = '0';
            dropdown.style.display = 'none';
        });

        // Remove 'active' class from all links
        document.querySelectorAll('.navmenu-link-title').forEach(link => {
            link.classList.remove('active');
        });

        // Set first tab as active if it exists
        if (dropdownLinks.length > 0) {
            dropdownLinks[0].classList.add('active');
            const parentLi = dropdownLinks[0].closest('li');
            if (parentLi) {
                const dropdown = parentLi.querySelector('.nav-dropdown');
                if (dropdown) {
                    dropdown.style.opacity = '1';
                    dropdown.style.display = 'block';
                }
            }
        }
    }

    // Function to handle tab switching
    function switchTab(clickedLink) {
        // Hide all dropdowns
        document.querySelectorAll('.nav-dropdown').forEach(dropdown => {
            dropdown.style.opacity = '0';
            dropdown.style.display = 'none';
        });

        // Remove 'active' class from all links
        document.querySelectorAll('.navmenu-link-title').forEach(link => {
            link.classList.remove('active');
        });

        // Add 'active' class to the clicked link
        clickedLink.classList.add('active');

        // Show the dropdown menu related to this link
        const parentLi = clickedLink.closest('li');
        if (parentLi) {
            const dropdown = parentLi.querySelector('.nav-dropdown');
            if (dropdown) {
                dropdown.style.opacity = '1';
                dropdown.style.display = 'block';
            }
        }
    }

    // Set initial state - first tab active
    resetToOriginalState();

    // Add event listeners for both mouseover and click
    dropdownLinks.forEach(link => {
        // Mouseover event
        link.addEventListener('mouseover', function(e) {
            e.preventDefault();
            switchTab(this);
        });

        // Click event
        link.addEventListener('click', function(e) {
            e.preventDefault();
            switchTab(this);
        });
    });

    // Add mouseleave event to the mega nav container
    if (megaNav) {
        document.addEventListener('mouseover', function(e) {
            // Check if the mouse is NOT over the mega nav or any of its children
            if (!megaNav.contains(e.target)) {
                resetToOriginalState();
            }
        });
    }
});